import React from "react";
import { dialog, InfiniteScroll, Progress } from "../../../../nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import InputFactory from "../../../../components/InputFactory";
import { toDisplayCase } from "../../../../nq-component";
import NavBar from "../../../../components/navbar";
import Table from "../../../../components/Table";
import CollapseView from "./components/CollapseView";
import AuditLogsPresenter from "./AuditLogsPresenter";
import RightSidebar from "../../../../components/RightSidebar";
import PageHeader from "../../../../components/PageHeader";

class AuditLogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AuditLogsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
    };
  }

  getCollectionName() {
    return "audit_logs";
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  closeDialog() {
    dialog.close();
  }

  onClickImport() {
    this.presenter.onClickImport();
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.searchSubmit(where);
  }

  onCollapse(index) {
    const audit = this.state.objects[index];
    return <CollapseView audit={audit} />;
  }

  formatFields(fields) {
    const { user, ...rest } = fields;

    return {
      user: { type: "String", label: "User" },
      ...rest,
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      const { ...rest } = object || {};

      return {
        ...rest,
        user: object.user?.email || "N/A",
      };
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading } = this.state;

    if (!schema) return <Progress />;
    return (
      <>
        <NavBar
          action={() => {
            return (
              <div className="dropdown dropstart d-inline-block">
                <i
                  role="button"
                  data-bs-toggle="dropdown"
                  className="bi bi-three-dots-vertical"
                ></i>
                <div className="dropdown-menu fs-xs ">
                  <button
                    onClick={this.onClickExport.bind(this)}
                    className="dropdown-item py-3"
                    style={{ backgroundColor: "#82c14a", color: "white" }}
                  >
                    <i className="fas fa-file-csv me-2"></i>
                    Export Data
                  </button>
                </div>
              </div>
            );
          }}
        />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <PageHeader
                  title={
                    schema.label || toDisplayCase(this.getCollectionName())
                  }
                  subtitle={schema.description || "Audit Logs"}
                  icon="bi bi-box-seam"
                />
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <Search
                  schemas={this.getSchemas()}
                  className="mt-3"
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
                <div className="text-nowrap mt-3">
                  <i
                    className="bi bi-filter fs-1"
                    onClick={() => this.setState({ showMobileFilters: true })}
                    style={{ color: "#83c14a" }}
                  ></i>
                </div>
              </div>

              <Table
                fields={this.formatFields(schema.fields)}
                objects={this.formatObjects(objects)}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["acl", "password", "message", "collection", "objectId"],
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                progress={loading}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(AuditLogsPage);
